module.exports = __webpack_public_path__ + "resources/img/img_tibero.209f7321e8df14ce1e99099332573aaa.png";